import React, { useState } from 'react';
import cx from 'classnames';
import FaMinus from 'react-icons/lib/fa/minus';
import FaPlus from 'react-icons/lib/fa/plus';
import FaTrash from 'react-icons/lib/fa/trash';
import { Col, ControlLabel, FormControl, Row } from 'react-bootstrap';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Button, AsyncSelectMenu, DataTable } from '../../../../../common/components';
import './SchemeChannels.scss';

const SchemeChannels = ({
  schemeName,
  schemeId,
  channelsTableName,
  removeChannel,
  assignChannel,
  filterChannel,
}) => {
  const [showChannels, setShowChannels] = useState(false);
  const [channelToAdd, setChannelToAdd] = useState(null);
  const toggleShowChannels = () => {
    setShowChannels(!showChannels);
  };

  const removeChannelFromScheme = (channelId) => () => {
    removeChannel(schemeId, channelId);
  };

  const assignChannelToScheme = (channelId) => () => {
    assignChannel(schemeId, channelId);
  };

  const formatRemoveChannel = (cell) => {
    return (
      <div
        className="scheme-channels--remove-icon"
        onClick={removeChannelFromScheme(cell)}
      >
        <FaTrash />
      </div>
    );
  };

  const handleSelectChannel = (option) => {
    if (option) {
      setChannelToAdd(option.value);
    } else {
      setChannelToAdd(null);
    }
  };

  const handleFilterChannels = (event) => {
    if (event) {
      filterChannel(event.target.value);
    }
  };

  return (
    <div className={'scheme-channels--collapsed-box'}>
      <div
        className={cx('scheme-channels--toggle-btn', {
          active: showChannels,
        })}
        onClick={toggleShowChannels}
      >
        <h4>{schemeName}</h4>
        {showChannels ? <FaMinus /> : <FaPlus />}
      </div>
      {showChannels && (
        <div className={'scheme-channels--channels'}>
          <div className={'scheme-channels--add-channel-row'}>
            <Row>
              <Col sm={5}>
                <ControlLabel>Search for channel to add...</ControlLabel>
              </Col>
              <Col sm={6}>
                <ControlLabel>Search existing channels...</ControlLabel>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <AsyncSelectMenu
                  url={'/channels'}
                  optionValuePath={'id'}
                  onChangeCallback={handleSelectChannel}
                  isClearable
                />
              </Col>
              <Col sm={1}>
                {channelToAdd && (
                  <Button
                    label={'Add Channel'}
                    handleClick={assignChannelToScheme(channelToAdd)}
                    bsStyle={'primary'}
                  />
                )}
              </Col>
              <Col sm={4}>
                <FormControl onChange={handleFilterChannels} />
              </Col>
            </Row>
          </div>

          <DataTable
            source={'channels'}
            name={channelsTableName}
            showTotal
            autoFilters={[
              { type: 'filter[schemes]', value: schemeId },
              { type: 'page[limit]', value: 20 },
            ]}
          >
            <TableHeaderColumn dataField="id" isKey hidden />
            <TableHeaderColumn dataField="name" dataSort>
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="id"
              dataFormat={formatRemoveChannel}
              width={'40px'}
            />
          </DataTable>
        </div>
      )}
    </div>
  );
};

export default SchemeChannels;
